import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'

const QUESTION_KEY = 'sustainability'

const OPTIONS = [
  {
    value: 'Top priority',
    translationKey: 'pages.onboarding.sustainability.options.topPriority',
    subtextKey: 'pages.onboarding.sustainability.subtexts.topPriority',
  },
  {
    value: 'Somewhat important',
    translationKey: 'pages.onboarding.sustainability.options.somewhat',
    subtextKey: 'pages.onboarding.sustainability.subtexts.somewhat',
  },
  {
    value: 'Not really',
    translationKey: 'pages.onboarding.sustainability.options.notReally',
    subtextKey: 'pages.onboarding.sustainability.subtexts.notReally',
  },
]

export default function SustainabilityPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How important is sustainability in your decision-making?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  // Transform options to the format expected by QuestionPage
  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    subtext: t(option.subtextKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.sustainability.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
